import { AuthGuardService as AuthGuard } from './core/guards/auth-guard.service';
import { MenuComponent } from './components/menu/menu.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

const routes: Routes = [
	{ path: '', redirectTo: 'auth', pathMatch: 'full' },
	{
		path: 'auth',
		loadChildren: () =>
			import('./pages/auth/auth.module').then((m) => m.AuthModule),
	},
	{
		path: 'home',
		canActivate: [AuthGuard],
		component: MenuComponent,
		loadChildren: () =>
			import('./pages/home/home.module').then((m) => m.HomeModule),
	},
	{
		path: 'terms-and-conditions',
		loadChildren: () =>
			import('./pages/terms-and-conditions/terms-and-conditions.module').then(
				(m) => m.TermsAndConditionsModule
			),
	},
	{
		path: 'privacy-policy',
		loadChildren: () =>
			import('./pages/privacy-policy/privacy-policy.module').then(
				(m) => m.PrivacyPolicyModule
			),
	},
	{
		path: 'forgot-password',
		loadChildren: () =>
			import('./pages/forgot-password/forgot-password.module').then(
				(m) => m.ForgotPasswordModule
			),
	},
	{
		path: 'support',
		loadChildren: () =>
			import('./pages/support/support.module').then((m) => m.SupportModule),
	},

	{ path: '**', redirectTo: 'home' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
